import React from 'react';
import './General.css';
import './IntelliCulture.css';
import './Work.css';
import IntelliCultureGrphics from './IntelliCultureGraphics';

interface HomeProps {
  visibilityIndex: number,
  setVisibilityIndex: (arg: number) => void
}

const summary = "Designed IntelliCulture's website and UI for a minimum viable farm vehicle tracker using mockup tools. Designed the company's website."

const IntelliCulture: React.FC<HomeProps> = ({visibilityIndex, setVisibilityIndex}) => {
  return (
    <div className="Main">
      <div className="Work">
        <h1><div className="Bracket">{"{"}</div></h1>
        <h1 className="Indented"><div className="Tag">Company</div>:&nbsp;<a className="CompanyLink" href="https://www.intelliculture.com/"  target="_blank">"IntelliCulture"</a>,</h1>
        <h1 className="Indented"><div className="Tag">Year</div>:&nbsp;"2018",</h1>
        <h1 className="Indented"><div className="Tag">Title</div>:&nbsp;"UX Desginer",</h1>
        <h1 className="Indented"><div className="Tag">Summary</div>:&nbsp;&nbsp;<div className="Bracket">{"["}</div></h1>
        <h1 className="DoubleIndented">"{summary}"</h1>
        <h1 className="Indented"><div className="Bracket">{"]"}</div></h1>
        <h1 className="Indented"><div className="Tag">Nav</div>:&nbsp;<div className="Bracket">{"["}</div></h1>
        <div className="DoubleIndented">
          <h1 className="NavButton" onClick={() => {
            setVisibilityIndex(0)}
            }>
              Intro
          </h1>
          <h1 className="NavButton" onClick={() => {
            setVisibilityIndex(visibilityIndex + 1)}
            }>
              Next
          </h1>
          <h1 className="NavButton" onClick={() => {
            setVisibilityIndex(visibilityIndex - 1)}
            }>
              Back
          </h1>
        </div>
        <h2 className="Indented"><div className="Bracket">{"]"}</div></h2>
        <h1 className="Bracket">{"}"}</h1>
      </div>
      <IntelliCultureGrphics/>
    </div>
  );
}

export default IntelliCulture;
